import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles//crud.css';
import '../../styles//botones_dflt.css';
import Spinner from "../spinner";
import {listar_Polizas, eliminarPoliza} from '../../services/apiPolizas.js';
import {convertirFechaParaInputDate} from '../../functions/fileFunctions.js';
import FiltrosPolizas from "../filters/filtros_polizas.js"; 
import * as alerts from '../../functions/alerts.js';


const CrudTable = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]); // Estado para almacenar filas
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // Control del modal de eliminación
  const [deleteIndex, setDeleteIndex] = useState(null); // Índice de la fila a eliminar
  const navigate = useNavigate();
  const irAFormulario = (id) => { navigate(`/formulario_polizas/${id}`);};

    // Cargar datos desde la API al montar el componente
    const fetchData = async (filtros) => {
      try{ 
        const json = await listar_Polizas(filtros);
        const formattedData = json.polizas.map((item) => ({
            id: item.id,
            numero: item.numero,
            cliente: item.cliente,
            compania: item.compania,
            valor: item.valor,
            ramo: item.ramo,
            fechaEmision: convertirFechaParaInputDate(item.fechaEmision),
            fechaVencimiento: convertirFechaParaInputDate(item.fechaVencimiento),
            valorPrima: item.valorPrima,
            porcentaje: item.porcentaje
        }));
        setData(formattedData);
        setLoading(false);
        } catch (error) {
          console.error('Error al cargar los datos:', error);
      }
    };

  const storedUser = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
      fetchData({});
  }, []);

  const openDeleteModal = (index) => {
    setDeleteIndex(index);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const confirmDelete = async () => {
    const response = await eliminarPoliza(data[deleteIndex].id,storedUser);
    if (response.ok) {
      alerts.handleSuccess('Éxito!','Póliza eliminada correctamente')
    } else {
      console.error('Error al eliminar la póliza:', response.statusText);
    }
    fetchData({});
    closeDeleteModal();
  };

  return (
    <>
    <div>
      <FiltrosPolizas onBuscar={fetchData}/>
    </div>
    <div className="crud-table">
      {!loading && <button className='button_new' onClick={() => irAFormulario(-1)}>Añadir Nueva Poliza</button>}
      {/* Tabla */}
      {loading ? <Spinner /> :
      <table>
        <thead>
          <tr>
            <th>Numero</th>
            <th>Cliente</th>
            <th>Compañía</th>
            <th>Valor Prima Neta</th>
            <th>Ramo</th>
            <th>Fecha Emisión</th>
            <th>Fecha Vencimiento</th>
            <th>Valor Prima Total</th>
            <th>Porcentaje Comisión</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <tr key={item.id}>
                <td>{item.numero}</td>
                <td>{item.cliente}</td>
                <td>{item.compania}</td>
                <td>{item.valor}</td>
                <td>{item.ramo}</td>
                <td>{item.fechaEmision}</td>
                <td>{item.fechaVencimiento}</td>
                <td>{item.valorPrima}</td>
                <td>{item.porcentaje}</td>
                <td>
                   <button className='editar' onClick={() => irAFormulario(item.id)}>Editar</button>
                   <button className='eliminar' onClick={() => openDeleteModal(index)}>Eliminar</button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9">No hay datos</td>
            </tr>
          )}
        </tbody>
      </table>
      }
      {/* Modal de Confirmación de Eliminación */}
      {isDeleteModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>Confirmar Eliminación</h2>
            <p>¿Estás seguro de que deseas eliminar este registro?</p>
            <button onClick={confirmDelete}>Sí, eliminar</button>
            <button onClick={closeDeleteModal}>Cancelar</button>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default CrudTable;